/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { CursorSearchResponseQuizBankSearchRes } from '../_model/cursorSearchResponseQuizBankSearchRes';
import type { QuizBankSearchReq } from '../_model/quizBankSearchReq';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 카테고리(초등 수학)로 문항을 조회한다. cursor 가 없으면 첫 페이지로 보고 필터 건수(facets)를 함께 계산하고, cursor 가 있으면(더 보기) 목록만 내린다.
 * @summary 문제 은행 문항 검색
 */
export const searchItems = (
  quizBankSearchReq: BodyType<QuizBankSearchReq>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<CursorSearchResponseQuizBankSearchRes>(
    {
      url: `/quiz-bank/items/search`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: quizBankSearchReq,
      signal,
    },
    options,
  );
};

export const getSearchItemsMutationKey = () => ['searchItems'] as const;

export const getSearchItemsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchItems>>,
    TError,
    SearchItemsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchItems>>,
  TError,
  SearchItemsMutationVariables,
  TContext
> => {
  const mutationKey = getSearchItemsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchItems>>,
    SearchItemsMutationVariables
  > = props => {
    const { data } = props ?? {};

    return searchItems(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchItemsMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchItems>>
>;
export type SearchItemsMutationBody = BodyType<QuizBankSearchReq>;
export type SearchItemsMutationError = ErrorType<unknown>;
export type SearchItemsMutationVariables = {
  data: BodyType<QuizBankSearchReq>;
};

/**
 * @summary 문제 은행 문항 검색
 */
export const useSearchItems = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchItems>>,
      TError,
      SearchItemsMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchItems>>,
  TError,
  SearchItemsMutationVariables,
  TContext
> => {
  return useMutation(getSearchItemsMutationOptions(options), queryClient);
};
